
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/[landingPages]",
      function () {
        return require("private-next-pages/lp/[landingPages].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/[landingPages]"])
      });
    }
  